<nts-base-checkbox-text-box 
    #baseCheckboxTextBox 
    [(checkStatus)]="propertyViewModel.typedValue"
    [label]="propertyViewModel.metadataDescription"
    [isDisabled]="!propertyViewModel.enabled">
</nts-base-checkbox-text-box>